import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState, useRef } from 'react';
import { Video as CotopaxiVideo } from '@as/cotopaxi';
import { useDispatch } from 'react-redux';
import { analyticsActions } from '../../redux/analytics/actions/AnalyticsActions.creators';
export const NativeVideo = ({ url, description, overlayTheme, withOverlay, play, pause, stop, autoPlay, loop, poster, }) => {
    const player = useRef(null);
    const [showOverlay, setShowOverlay] = useState(withOverlay);
    const [videoLoaded, setVideoLoaded] = useState(false);
    const dispatch = useDispatch();
    const playVideo = () => {
        var _a;
        if ((_a = player === null || player === void 0 ? void 0 : player.current) === null || _a === void 0 ? void 0 : _a.play) {
            player.current.play();
        }
        showOverlay && setShowOverlay(false);
    };
    const pauseVideo = () => {
        var _a;
        if ((_a = player === null || player === void 0 ? void 0 : player.current) === null || _a === void 0 ? void 0 : _a.pause) {
            player.current.pause();
        }
    };
    const stopVideo = () => {
        var _a;
        if ((_a = player === null || player === void 0 ? void 0 : player.current) === null || _a === void 0 ? void 0 : _a.pause) {
            player.current.pause();
            player.current.currentTime = 0;
        }
    };
    const handleTrackAction = () => {
        dispatch(analyticsActions.productVideoLoaded(url));
    };
    useEffect(() => {
        var _a;
        if (((_a = player === null || player === void 0 ? void 0 : player.current) === null || _a === void 0 ? void 0 : _a.oncanplay) && !videoLoaded) {
            player.current.addEventListener('oncanplay', handleTrackAction);
            setVideoLoaded(true);
            return () => window.removeEventListener('oncanplay', handleTrackAction);
        }
    }, [player]);
    useEffect(() => {
        pause && pauseVideo();
    }, [pause, player]);
    useEffect(() => {
        play && playVideo();
    }, [play, player]);
    useEffect(() => {
        stop && stopVideo();
    }, [stop, player]);
    return (_jsx(CotopaxiVideo, { nativePlayer: true, nativePlayerRef: player, nativePlayerAutoPlay: autoPlay, nativePlayerLoop: loop, url: url, poster: poster, withOverlay: showOverlay, description: description, onOverlayClick: playVideo, overlayTheme: overlayTheme }));
};
